// Form to enter details and if match then will get reset password link in email
to reset password
<template>
  <div class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-sm md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl cobalt-text-color">
             Reset Your Password
            </div>
          </div>
          <p class="text-xs mt-1">
            Enter details to get password reset link
          </p>
          <form class="mt-5 space-y-6" novalidate>
            <div class="rounded-sm">
              <div class="flex flex-col">
                <text-input
                id="email"
                  label="Email Address"
                  :class="{ 'border-red-400': v$.form.email.$error }"
                  v-bind:value="form.email"
                  @blur="v$.form.email.$touch()"
                  v-on:keyup="form.email = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.email.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button
                id="signin"
                type="button"
                @click="getResetLink"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus-border-navy"
                aria-required="true"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                <span>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  name: "Forgot Password",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: function() {
    return {
      form: { email: "" },
    };
  },
  validations() {
      return {
        form: {
          email: {
            required,
          }
        },
      };
  },
  mounted() {},
  methods: {
    getResetLink: function() {
      this.v$.form.$touch(this.v$.form.errors);
      console.log(this.v$.form);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.$store.dispatch("forgotPassword", this.form).then((result) => {
        console.log(result)
       localStorage.setItem('forgot_email',this.form.email);
        this.$toast.success("OTP sent to your email, enter new passoword and OTP");
        this.$router.push("/reset-password");
        })
        .catch((error) => {
          this.$toast.error(error);
         console.log(error)
        });
    },
  },
};
</script>
